<div class="w-full h-fit relative overflow-hidden rounded-default m-auto">

  <div class="sticky z-2 -mt-[1.75rem]  flex justify-end  m-auto w-11/12 md:w-9/12 lg:w-[613px] top-0 right-0 left-0">
    <button (click)="closeModal()" (keydown.escape)="closeModal()"
      class=" flex justify-center items-center text-white rounded-full p-1 bg-white hover:bg-gray-100 max-w-[24px] ml-auto">
      <ion-icon name="close" class="w-5 h-5 text-xl text-black"></ion-icon>
    </button>
  </div>

  <!-- Skeleton loading state -->
  <ng-container *ngIf="loading">
    <div class="course-details-modal max-h-[100%] px-4 pt-0 pb-2 grid grid-rows-[auto_1fr] bg-white m-auto w-11/12 md:w-9/12 lg:w-[613px] rounded-default overflow-y-auto overflow-x-hidden relative">
      <div class="flex flex-col first-section mb-4 -ml-4 w-[calc(100%+2rem)] px-4 pb-3 pt-4 rounded-b-default relative">
        <div class="w-full grid grid-cols-[auto_1fr] gap-2 mb-3">
          <ion-skeleton-text [animated]="true" class="h-[50px] w-[77px] rounded-md"></ion-skeleton-text>
          <ion-skeleton-text [animated]="true" class="h-5 w-3/4 rounded-md self-center"></ion-skeleton-text>
        </div>
        <div class="flex flex-col gap-2 w-full">
          <ion-skeleton-text [animated]="true" class="h-2 w-full rounded-md"></ion-skeleton-text>
          <div class="flex items-center gap-5">
            <ion-skeleton-text [animated]="true" class="h-4 w-36 rounded-md"></ion-skeleton-text>
            <ion-skeleton-text [animated]="true" class="h-4 w-28 rounded-md"></ion-skeleton-text>
          </div>
          <div class="flex gap-3 items-center">
            <ion-skeleton-text [animated]="true" class="h-7 w-24 rounded-lgmax"></ion-skeleton-text>
            <ion-skeleton-text [animated]="true" class="h-7 w-20 rounded-lgmax"></ion-skeleton-text>
          </div>
        </div>
      </div>
      <div class="w-full flex flex-col gap-2 mb-3">
        <ion-skeleton-text [animated]="true" class="h-4 w-16 rounded-md"></ion-skeleton-text>
        <div class="flex flex-col gap-2">
          <ion-skeleton-text [animated]="true" class="h-10 w-full rounded-md"></ion-skeleton-text>
        </div>
      </div>
      <div class="flex justify-center items-center sticky -bottom-3 pb-3 pt-1 right-0 left-0">
        <ion-skeleton-text [animated]="true" class="h-10 w-full rounded-default"></ion-skeleton-text>
      </div>
    </div>
  </ng-container>

  <!-- Actual content -->
  <ng-container *ngIf="!loading">
  <div
    class="course-details-modal max-h-[100%] px-4 pt-0 pb-2 grid grid-rows-[auto_1fr] bg-white m-auto w-11/12 md:w-9/12 lg:w-[613px] rounded-default overflow-y-auto overflow-x-hidden relative">

    <div class="flex flex-col first-section mb-4 -ml-4 w-[calc(100%+2rem)] px-4 pb-3 pt-4 rounded-b-default relative "
    [ngClass]="{'overflow-x-hidden': fromCalendar}">

      <div class="w-full grid  gap-2 mb-3" [ngClass]="teaserUrl ? 'grid-cols-[1fr]' : 'grid-cols-[auto_1fr]'">
        <ng-container *ngIf="!teaserUrl">
          <div *ngIf="coverUrl" class="background-blur-img h-[50px] w-[77px] overflow-hidden"
            [ngStyle]="{'background-image': 'url(' + coverUrl + ')'}">
            <img [src]="coverUrl" class="card-img h-full w-full object-contain z-5 m-auto">
          </div>

          <div *ngIf="!coverUrl" class="h-[50px] w-[77px] overflow-hidden relative">
            <div
              class="bg-default-course-cover absolute top-0 bottom-0 left-0 right-0 bg-transparent flex justify-center items-center ">
              <span class="overflow-text-cover-3 text-white font-bold text-xxs text-center px-3 lg:px-4"> {{courseName}}
              </span>
            </div>
            <div class="absolute bottom-0 right-0 items-center h-[6px] w-[20px] flex justify-center ">
              <img [src]="usuario.workspace.logo" class="h-full max-w-full object-contain opacity-90 rounded-default" />
            </div>
          </div>
        </ng-container>


        <div *ngIf="teaserUrl" (click)="teaserIsPlaying = true"
          class="background-blur-img h-[200px] md:h-[300px] lg:h-[330px] w-full overflow-hidden cursor-pointe relative rounded-t-default"
          [ngStyle]="{'background-image': 'url(' + coverUrl + ')'}">
          <img *ngIf="!teaserIsPlaying" [src]="coverUrl"
            class="card-img h-full w-full object-contain z-1 m-auto rounded-t-default">
          <ion-icon *ngIf="!teaserIsPlaying" name="caret-forward-circle"
            class="center-element-translate play-video-icon text-[82px] text-white  z-3 rounded-full "></ion-icon>
          <div *ngIf="!teaserIsPlaying"
            class="absolute top-0 left-0 right-0 bottom-0 z-2 bg-transparent teaser-gradient rounded-t-default"></div>

          <video *ngIf="teaserIsPlaying" class="h-full object-contain w-full video-teaser-blur" [src]="teaserUrl"
            [poster]="coverUrl" [autoplay]="true" controlsList="nodownload" controls></video>
        </div>

        <b class="text-base overflow-text-cover-2 pr-1" [ngClass]="{'h-10': !teaserUrl}">{{courseName}}</b>
      </div>

      <div class="flex flex-col gap-2 w-full">
        <app-progress-bar [progress]="percentage / 100" class="w-full" customClass="" />

        <div class="flex items-center justify-between gap-4">
          <div class="flex items-center gap-5">
            <span class="text-xs  text-gray-600"> Temas realizados: {{completedTopics || 0}}/{{allTopics}}</span>
            <b *ngIf="duration" class="text-xxs text-primary">
              <mat-icon class="mdi mdi-account-clock text-sm text-primary"></mat-icon>
              Duración aproximada: {{duration}}
            </b>
          </div>

          <div *ngIf="fromCalendar && courseStartDate" class="flex items-center text-xs text-default_text">
            <span><b>Fecha: </b>{{courseStartDate | date:'dd/MM/yyyy hh:mm a'}}</span>
          </div>


        </div>
        <p *ngIf="address" class="text-xs  text-primary flex items-center">
            <mat-icon class="mdi mdi-map-marker text-base mr-1"></mat-icon>
              Lugar: <span class="text-default_text pl-1">{{address}}</span>
        </p>

        <!-- <div *ngIf="courseTags?.length" class="flex gap-1 md:gap-3 flex-wrap">
          <ng-container *ngFor="let tag of courseTags">
            <app-chip *ngIf="tag.type === 'level'" customClass="px-2 py-1 md:px-3 md:py-1"
            [bgColor]="
            tag.type === 'level' &&  tag.name === 'Básico' ? '#00e396' :
            tag.type === 'level' &&  tag.name === 'Intermedio' ? '#ffb700' :
            '#ff4242'
            ">
              <span class="no-wrap-chip-comp text-white  flex justify-center items-center gap-1 text-xxs md:text-xs leading-[10px] md:leading-3 md:font-medium">
                  <mat-icon class="mdi text-xxs md:text-xs leading-[10px] md:leading-3 text-white" [ngClass]="tag.name ? 'mdi-star' : 'mdi-star-outline'"></mat-icon>
                  <mat-icon class="mdi text-xxs md:text-xs leading-[10px] md:leading-3 text-white" [ngClass]="tag.name === 'Intermedio' || tag.name === 'Avanzado' ? 'mdi-star' : 'mdi-star-outline'"></mat-icon>
                  <mat-icon class="mdi text-xxs md:text-xs leading-[10px] md:leading-3 text-white" [ngClass]="tag.name === 'Avanzado' ? 'mdi-star' : 'mdi-star-outline'"></mat-icon>
                  {{tag.name}}
              </span>
            </app-chip>

            <app-chip *ngIf="tag.type === 'competency'" customClass="px-2 py-1 md:px-3 md:py-1" bgColor="#1d89af">
              <span class="no-wrap-chip-comp text-white text-xxs md:text-xs leading-[10px] md:leading-3 md:font-medium flex justify-center items-center gap-1">
                <mat-icon class="mdi mdi-heart  text-xxs md:text-xs leading-[10px] md:leading-3 text-white "></mat-icon>
                {{tag.name}}
              </span>
            </app-chip>

            <app-chip *ngIf="tag.type === 'hability'" customClass="px-2 py-1 md:px-3 md:py-1" bgColor="#9b98fe">
              <span class="no-wrap-chip-comp text-white text-xxs md:text-xs leading-[10px] md:leading-3 md:font-medium flex justify-center items-center gap-1">
                <mat-icon class="mdi mdi-lightbulb-variant  text-xxs md:text-xs leading-[10px] md:leading-3 text-white"></mat-icon>
                {{tag.name}}
              </span>
            </app-chip>
          </ng-container>
        </div> -->

        <p *ngIf="description" class="text-sm break-words" [innerHtml]="description | trustHtml"></p>

        <div class="flex flex-col gap-1">
          <!-- <b class="text-sm">Actividades:</b> -->
          <div class="flex gap-3 items-center">

            <app-chip *ngIf="hasEvaluation" customClass="px-3 py-[6px] border-1" bgColor="#fff" borderColor="#CE98FE">
              <span
                class="no-wrap-chip-comp text-white text-xxs md:text-xs leading-[10px] md:leading-3 md:font-medium flex justify-center items-center gap-1"
                mat-raised-button matTooltip="Curso con evaluación" matTooltipClass="default-angular-tooltip"
                matTooltipPosition="above" aria-label="shows tooltip">
                <mat-icon
                  class="mdi mdi-human-male-board-poll    text-xxs md:text-xs leading-[10px] md:leading-3 text-[#CE98FE] "></mat-icon>
                <span class="text-[#CE98FE]">Evaluación</span>
              </span>
            </app-chip>

            <app-chip *ngIf="hasTasks" customClass="px-3 py-[6px] border-1" bgColor="#fff" borderColor="#5458EA">
              <span
                class="no-wrap-chip-comp text-white text-xxs md:text-xs leading-[10px] md:leading-3 md:font-medium flex justify-center items-center gap-1"
                mat-raised-button matTooltip="Curso con tarea" matTooltipClass="default-angular-tooltip"
                matTooltipPosition="above" aria-label="shows tooltip">
                <mat-icon
                  class="mdi mdi-notebook-check   text-xxs md:text-xs leading-[10px] md:leading-3 text-[#5458EA] "></mat-icon>
                <span class="text-[#5458EA]">Tarea</span>
              </span>
            </app-chip>

            <app-chip *ngIf="hasSurvey" customClass="px-3 py-[6px] border-1" bgColor="#fff" borderColor="#E57A9B">
              <span
                class="no-wrap-chip-comp text-white text-xxs md:text-xs leading-[10px] md:leading-3 md:font-medium flex justify-center items-center gap-1"
                mat-raised-button matTooltip="Curso con encuesta" matTooltipClass="default-angular-tooltip"
                matTooltipPosition="above" aria-label="shows tooltip">
                <mat-icon
                  class="mdi mdi-order-bool-ascending-variant   text-xxs md:text-xs leading-[10px] md:leading-3 text-[#E57A9B] "></mat-icon>
                <span class="text-[#E57A9B]">Encuesta</span>
              </span>
            </app-chip>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full flex flex-col gap-2 mb-3">
      <span class="text-sm">Tema(s):</span>
      <app-dropdown-content *ngFor="let topic of topics; let i = index" [isOpen]="topicActiveIdx.includes(i)"
        (itemClicked)="openTopicDetail(i)" class="border-b-1 border-gray-250">
        <div header class="grid grid-cols-[1fr_auto] gap-3 w-full text-sm font-bold py-2">
          <span>{{topic.name}}</span>
          <mat-icon *ngIf="topic?.medias?.length" class="mdi text-sm cursor-pointer"
            [ngClass]="topicActiveIdx.includes(i) ? 'mdi-chevron-up' : 'mdi-chevron-down'"></mat-icon>
        </div>

        <div content class="pb-3 pr-3 pl-[18px]">
          <p *ngIf="topic.description">{{topic.description}} </p>
          <ul class="ml-3 list-disc list-outside text-left text-base">
            <li class="mt-1 text-xs" *ngFor="let media of topic.medias">
              <span>{{media.title}} </span>
            </li>
          </ul>
        </div>
      </app-dropdown-content>
    </div>

    <div class="bg-white z-2  justify-center items-center sticky -bottom-3 pb-3 pt-1 right-0 left-0 grid"
    [ngClass]="{' grid-cols-[1fr] lg:grid-cols-[2fr_3fr] gap-3': hasCalendarIntegrationAvailable && !eventIsSynced,
    'grid-cols-1': !hasCalendarIntegrationAvailable || eventIsSynced}"
    >
    <app-tertiary-button
    *ngIf="hasCalendarIntegrationAvailable && !eventIsSynced"
    normalBtn="true"
    customClassAppBtn="text-xs border-primary text-primary w-full"
    (btnClick)="sendCalendarEvent()"
    class="w-full"
    >
      <span class="text-xs leading-5 flex items-center justify-center w-full">
        Añadir a mi calendario
        <mat-icon class="mdi mdi-calendar-import text-lg ml-2 leading-5"></mat-icon>
      </span>
    </app-tertiary-button>

     <div [ngClass]="rewardCoins ? 'grid grid-cols-[auto_1fr] gap-2' : 'flex'">
       <div *ngIf="rewardCoins"
         class="rounded-xxl border-custom-lilac bg-white py-[6px] px-3 border-1 flex items-center justify-center gap-1  z-2">
         <b class="text-base leading-4 pt-[1px] md:pt-[2px]">{{rewardCoins}}</b>
         <div class="w-[19px] h-[19px]">
           <img *ngIf="coinCustomImage" [src]="coinCustomImage" class="w-full h-full object-contain">
           <ng-lottie *ngIf="!coinCustomImage" [options]="coinOptions" width="100%" height="100%"></ng-lottie>
         </div>
       </div>

       <ng-container *ngIf="fromCalendar">
         <app-primary-button (btnClick)="onClickBtnCalendar()" class="fromCalendar w-full  " normalBtn="true"
           [customClassAppBtn]="eventIsLocked || courseIsLocked ? 'force-gray-style w-full' : 'w-full'">
           <span class="text-xs leading-5 flex items-center justify-between w-full">
             Ir al curso

            <span  class="flex items-center gap-1 text-xs">
              <ng-container *ngIf="eventIsLocked">Podrás ingresar en la fecha indicada</ng-container>

              <mat-icon class="mdi mdi-chevron-right text-white text-lg leading-4 ml-3"
              [ngClass]="eventIsLocked || courseIsLocked ? 'mdi-lock' : 'mdi-chevron-right'">
              </mat-icon>
            </span>
           </span>
         </app-primary-button>
        </ng-container>

        <ng-container *ngIf="!fromCalendar">
         <app-primary-button (btnClick)="onClickBtn()" class="w-full  " normalBtn="true"
           [customClassAppBtn]="courseIsLocked ? 'opacity-40 w-full' : 'w-full'">
           <span class="text-xs leading-3 flex items-center justify-between w-full">Ir al curso
             <mat-icon class="mdi mdi-chevron-right text-white text-lg leading-4 ml-3"
               [ngClass]="courseIsLocked ? 'mdi-lock' : 'mdi-chevron-right'"></mat-icon>
           </span>
         </app-primary-button>
       </ng-container>

     </div>
    </div>

  </div>
  </ng-container>




</div>
